import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getCustomerApi,
  getCustomersApi,
  postCustomerApi,
  updateCustomerApi,
  updateCustomerMindApi,
} from "../../api/ecommerce/CustomerApi";
import {
  getArAnalyticApi,
  getQrAnalyticApi,
  postArAnalyticApi,
  postQrAnalyticApi,
} from "../../api/common/AnalyticApi";

const initialState = {
  customer: {},
  customers: [],
  page: 0,
  size: 10,
  search: "",
  sortdir: "",
  sortby: "",
  qrCustomer: "",
  qrAnalytic: {},
  arAnalytic: {},
  loading: false,
  saving: false,
};

export const getCustomer = createAsyncThunk(
  "customer/getCustomer",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getCustomerApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const getCustomers = createAsyncThunk(
  "customer/getCustomers",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getCustomersApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const postCustomer = createAsyncThunk(
  "customer/postCustomer",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postCustomerApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const updateCustomer = createAsyncThunk(
  "customer/updateCustomer",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateCustomerApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const updateCustomerMind = createAsyncThunk(
  "customer/updateCustomerMind",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateCustomerMindApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const getQrAnalytic = createAsyncThunk(
  "customer/getQrAnalytic",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getQrAnalyticApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const postQrAnalytic = createAsyncThunk(
  "customer/postQrAnalytic",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postQrAnalyticApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const getArAnalytic = createAsyncThunk(
  "customer/getArAnalytic",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getArAnalyticApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const postArAnalytic = createAsyncThunk(
  "customer/postArAnalytic",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postArAnalyticApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    addKeywordSearch: (state, action) => {
      state.search = action.payload;
    },
    addPage: (state, action) => {
      state.page = action.payload;
    },
    addSize: (state, action) => {
      state.size = action.payload;
    },
    addSortDir: (state, action) => {
      state.sortdir = action.payload;
    },
    addSortBy: (state, action) => {
      state.sortby = action.payload;
    },
    addqrCustomer: (state, action) => {
      state.qrCustomer = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCustomer.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCustomer.fulfilled, (state, action) => {
      state.customer = action.payload?.response ?? action.payload;
      state.loading = false;
    });
    builder.addCase(getCustomer.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getCustomers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCustomers.fulfilled, (state, action) => {
      state.customers = action.payload?.response ?? action.payload;
      state.loading = false;
    });
    builder.addCase(getCustomers.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(postCustomer.pending, (state) => {
      state.saving = true;
    });
    builder.addCase(postCustomer.fulfilled, (state, action) => {
      state.customer = action.payload?.response ?? action.payload;
      state.saving = false;
    });
    builder.addCase(postCustomer.rejected, (state) => {
      state.saving = false;
    });

    builder.addCase(updateCustomer.pending, (state) => {
      state.saving = true;
    });
    builder.addCase(updateCustomer.fulfilled, (state, action) => {
      state.customer = action.payload?.response ?? action.payload;
      state.saving = false;
    });
    builder.addCase(updateCustomer.rejected, (state) => {
      state.saving = false;
    })


    builder.addCase(updateCustomerMind.pending, (state) => {
      state.saving = true;
    });
    builder.addCase(updateCustomerMind.fulfilled, (state, action) => {
      state.customer = action.payload?.response ?? action.payload;
      state.saving = false;
    });
    builder.addCase(updateCustomerMind.rejected, (state) => {
      state.saving = false;
    })
      ;

    builder.addCase(getQrAnalytic.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getQrAnalytic.fulfilled, (state, action) => {
      state.qrAnalytic = action.payload?.response ?? action.payload;
      state.loading = false;
    });
    builder.addCase(getQrAnalytic.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(postQrAnalytic.pending, (state) => {
      state.saving = true;
    });
    builder.addCase(postQrAnalytic.fulfilled, (state, action) => {
      state.qrAnalytic = action.payload?.response ?? action.payload;
      state.saving = false;
    });
    builder.addCase(postQrAnalytic.rejected, (state) => {
      state.saving = false;
    });

    builder.addCase(getArAnalytic.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getArAnalytic.fulfilled, (state, action) => {
      state.arAnalytic = action.payload?.response ?? action.payload;
      state.loading = false;
    });
    builder.addCase(getArAnalytic.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(postArAnalytic.pending, (state) => {
      state.saving = true;
    });
    builder.addCase(postArAnalytic.fulfilled, (state, action) => {
      state.arAnalytic = action.payload?.response ?? action.payload;
      state.saving = false;
    });
    builder.addCase(postArAnalytic.rejected, (state) => {
      state.saving = false;
    });
  },
});

export default customerSlice.reducer;
export const { addKeywordSearch, addSortBy, addSortDir, addqrCustomer, addPage, addSize } = customerSlice.actions
